import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CountriesData, CountriesListDTO } from 'sharedGuiSmall/sharedModels/countriesDto';
import { IndustriesDto } from "sharedGuiSmall/sharedModels/industriesDto";
import { PositionsData, PositionsListDTO } from "sharedGuiSmall/sharedModels/PositionsDto";

declare let handleAngularHttpError: any;

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    industriesPromise: Promise<CountriesListDTO> | undefined;
    industries: IndustriesDto | undefined;

    countriesPromise: Promise<CountriesListDTO> | undefined;
    countries: CountriesData | undefined;

    positionsPromise: Promise<PositionsListDTO> | undefined;
    positions: PositionsData | undefined;

    profilePromise: Promise<string> | undefined;
    companyPromise: Promise<string> | undefined;
    cancelPromise: Promise<string> | undefined;
    changeEmailPromise: Promise<string> | undefined;
    checkPassPromise: Promise<string> | undefined;
    resendEmailPromise: Promise<string> | undefined;

    constructor(private http: HttpClient) {

    }

    LoadProfile(userID: number, login: string) {

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        
        let params = new HttpParams()
            .set('login', login)
            .set('userID', userID);
        let body = params.toString();

        const response = this.http.post<string>(window.coreApiUrl + 'Profile/LoadProfile', body, { headers: headers });
        this.profilePromise = lastValueFrom(response);
    }

    cancelEmail(userID: number, login: string) {

        let params = new HttpParams()
            .set('login', login)
            .set('userID', userID);

        const response = this.http.post<string>(window.coreApiUrl + 'Profile/CancelEmailChanging', null, { params });
        this.cancelPromise = lastValueFrom(response);
    }

    resendEmail(newUserEmail: string, userID: string) {

        let params = new HttpParams()
            .set('newUserEmail', newUserEmail)
            .set('userID', userID);

        const response = this.http.post<string>(window.coreApiUrl + 'Profile/ResendEmail', null, { params });
        this.resendEmailPromise = lastValueFrom(response);
    }

    changeEmail(userID: number, login: string, newEmail: string) {
        let params = new HttpParams()
            .set('userID', userID)
            .set('login', login)
            .set('newEmail', newEmail);

        const response = this.http.post<string>(window.coreApiUrl + 'Profile/ChangeEmailRequest', null, { params })
        this.changeEmailPromise = lastValueFrom(response);
    }

    checkPass(password: string, userID: number, login: string) {
        let params = new HttpParams()
            .set('password', password)
            .set('userID', userID)
            .set('login', login);

        const response = this.http.post<string>(window.coreApiUrl + 'Profile/CheckPassword', null, { params });
        this.checkPassPromise = lastValueFrom(response);
    }

    LoadCompany(companyId: string) {
        //let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        
        let params = new HttpParams()
            .set('companyId', companyId);
        let body = params.toString();

        const response = this.http.post<string>(window.appPath + 'Profile/CompanyJson', body, { headers: headers });
        this.companyPromise = lastValueFrom(response);
    }

    LoadCountries(userID: number) {
        let params = new HttpParams()
            .set('userID', userID);

        const response = this.http.get<string>(window.coreApiUrl + 'Profile/LoadCountries', { params });
        this.countriesPromise = lastValueFrom(response)
            .then((res: string) => {
                let data = JSON.parse(res);
                this.countries = data;
                return data;
            }).catch(function (reason) {
                console.error('Profile/LoadCountries error', reason);
                handleAngularHttpError(reason);
            });
    }

    LoadPositions(userID: number) {
        let params = new HttpParams()
            .set('userID', userID);

        const response = this.http.get<string>(window.coreApiUrl + 'Profile/LoadPositions', { params });
        this.positionsPromise = lastValueFrom(response)
            .then((res: string) => {
                let data = JSON.parse(res);
                this.positions = data;
                return data;
            }).catch(function (reason) {
                console.error('Profile/LoadPositions error', reason);
                handleAngularHttpError(reason);
            });
    }

    LoadIndustries(userID: number) {
        let params = new HttpParams()
            .set('userID', userID);

        const response = this.http.get<string>(window.coreApiUrl + 'Profile/LoadIndustries', { params });
        this.industriesPromise = lastValueFrom(response)
            .then((res: string) => {
                let data = JSON.parse(res);
                this.industries = data;
                return data;
            }).catch(function (reason) {
                console.error('Profile/LoadIndustries error', reason);
                handleAngularHttpError(reason);
            });
    }
}
